import 'cropperjs/dist/cropper.css';
import PageStyle from '@/styles/components/job-live/_index.module.scss';
import ComponentStyle from '@/styles/components/cropper-filter/_index.module.scss';
import CloseWhite from 'public/icons/closewhite.svg';
import Button from '@/components/button';
import { useTranslation } from 'react-i18next';

export function CareerCropper(props)
{
    function cropperClass(){
        let type = props.cropper_type.type
        switch(type){
        case 'logo_image':
            return ComponentStyle.CareerLogoImage
        case 'hero_image':
            return ComponentStyle.CareerHeroImage
        case 'about_image':
            return ComponentStyle.CareerAboutImage
        case 'gallery_image':
            return ComponentStyle.CareerGalleryImage
        case 'benefit_image':
            return ComponentStyle.CareerBenefitImage
        case 'team_image':
            return ComponentStyle.CareerTeamImage
        }
    }

    const {t} = useTranslation()
    function modal_title(type) {
        if (type === 'mobile_image') {
          return t('career:cropper:mobile');
        } else if (type === 'hero_image') {
          return t('career:cropper:desktop'); 
        } else {
          return t('career:cropper:default'); 
        }
      }
      
    return(
               <div className={`CropperModal ${PageStyle.Modalpopup} ${props.cropper_type?.type}`}>
                    <div className={`${ComponentStyle.CropImage} ${cropperClass()}`}>

                            <div className={ `${ComponentStyle.CropImage__Head}` }>
                            <h3>{modal_title(props.cropper_type.type)}</h3>
                            <div className = {`${ComponentStyle.ModalClose}`} onClick={(event)=>{
                                                                                                    props.viewProfileAction.closeCropperModal();
                                                                                                }}>
                                <CloseWhite />
                            </div>
                            </div>

                            <div className={ComponentStyle.CropImage__Inner}>
                                <div className='CustomCropperContainer'>
                                    <img src = '/images/pages/profilepic/profilepic.png'  className="Cropper__Image"/>

                                    <div className='CustomCropper'>
                                        <div className="CustomCropper__Acion mt20">

                                            <div className={ComponentStyle.CropImage__Actions}>
                                               <h3>{t('career:cropper:zoom')} </h3>
                                                <Button onClick={()=>{props.viewProfileAction.zoom_in()}}> <span>+</span></Button>
                                                <Button onClick={()=>{props.viewProfileAction.zoom_out()}}> <span  style={{marginBottom: "3px"}} >-</span> </Button>
                                            </div>
                                            <Button buttonstyle={`m0 ${ComponentStyle.primarybtn}`} onClick={()=>{
                                                                                                                    props.viewProfileAction.getCroppedImage(props);
                                                                                                                    document.querySelector('.CropperModal').style.visibility = 'hidden'
                                                                                                                }}>{t('career:cropper:button')}</Button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                    </div>
                </div>
         )

}